<template>
    <div class="cme-registration-form">
        <!-- Event Info Section -->
        <div class="event-top-wrapper">
            <div class="cme-event-info">
                <em class="new-text-lg text-color-default">Nächste Veranstaltung</em>
                <strong class="event-name new-text-xl">{{ event?.name || 'Veranstaltung in Vorbereitung' }}</strong>
                <div class="event-details new-text-lg">
                    <div class="event-speaker">
                        <strong>Referent:in:</strong> {{ event?.speaker || 'folgt in Kürze' }}
                    </div>
                    <div class="event-datetime">
                        <strong>Termin:</strong> {{ (event ? formatEventDate(event.start_at, event.end_at) : null) || 'folgt in Kürze' }}
                    </div>
                    <div class="event-excerpt">
                        <strong>Weitere Informationen:</strong> {{ event?.excerpt || 'folgen in Kürze' }}
                    </div>
                </div>

                <p class="text-color-default">{{ event?.description || 'Wir arbeiten aktuell an der nächsten Veranstaltung. Weitere Informationen werden bald hier veröffentlicht. Melden Sie sich an, um per E-Mail informiert zu werden, sobald der Termin feststeht.' }}</p>
            </div>

            <figure class="web-desktop">
                <img src="imgs/web/img_cme_doc.webp" alt="" srcset="imgs/web/img_cme_doc.webp 1x, imgs/web/img_cme_doc@2x.webp 2x">
            </figure>
        </div>

        <!-- Registration Form Section -->
        <form action="" method="POST" @submit.prevent="submit" novalidate>
            <input
                name="website"
                v-model="honeypotField"
                type="text"
                tabindex="-1"
                autocomplete="off"
                aria-hidden="true"
                style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;"
            >
            <input type="hidden" name="form_started_at" :value="formStartedAt">

            <strong class="new-text-xl">Anmelden und Einladungslink per E-Mail erhalten</strong>
            <p class="new-text-lg text-color-default">Melden Sie sich zur Fortbildung an und erhalten Sie den Einladungslink vor der Veranstaltung per E-Mail.</p>
            <div class="form-toggle-wrapper">
                <form-input-type-toggle
                    v-if="event"
                    name="register_event"
                    :label="getRegisterEventLabel()"
                    toggle-position="right"
                    :value="true"
                ></form-input-type-toggle>

                <form-input-type-toggle
                    name="cme_info"
                    label="Informationen zu weiteren Veranstaltungen erhalten"
                    toggle-position="right"
                    :value="true"
                ></form-input-type-toggle>

                <form-input-error
                    v-if="toggleValidationError"
                    :error="toggleValidationError"
                ></form-input-error>
            </div>

            <div class="col-2">
                <form-input-type-email
                name="email"
                label="E-Mail Adresse"
                :errors="errors.email"
                full-border
                required
            ></form-input-type-email>

            <form-input-type-text
                name="name"
                label="Name"
                :errors="errors.name"
                full-border
                required
            ></form-input-type-text>    
            </div>

            <div class="button-group">
                <v-button label="Zur Fortbildung anmelden" type="submit" full-width></v-button>

                <div>
                    <p class="text-color-default">Mit dem Absenden des Formulars stimmen Sie der Verarbeitung Ihrer personenbezogenen Daten für die jeweils oben ausgewählten Dienste zu. Weitere Informationen zu der Verarbeitung Ihrer Daten finden Sie in der <a href="/datenschutzerklarung" target="_blank">Datenschutzerklärung</a>.</p>

                    <p class="form-mandatory-fields">* Felder mit Sternchen (*) sind Pflichtfelder.</p>
                </div>
            </div>
        </form>

        <flash-alert
            v-if="showSuccessAlert"
            @closeAlert="closeAlert"
            text="Vielen Dank für Ihre Anmeldung!"
            position="top"
        ></flash-alert>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                event: null,
                errors: {},
                toggleValidationError: null,
                showSuccessAlert: false,
                honeypotField: '',
                formStartedAt: Math.floor(Date.now() / 1000)
            }
        },

        mounted() {
            this.loadUpcomingEvent()
        },

        methods: {
            async loadUpcomingEvent() {
                try {
                    const response = await axios.get('/api/cme/upcoming-event')
                    this.event = response.data.event
                } catch (error) {
                    console.error('Failed to load upcoming event:', error)
                }
            },

            formatEventDate(startAt, endAt) {
                if (!startAt || !endAt) {
                    return null
                }

                const start = new Date(startAt)
                const end = new Date(endAt)

                const dateOptions = { day: '2-digit', month: '2-digit', year: 'numeric' }
                const timeOptions = { hour: '2-digit', minute: '2-digit' }

                const dateStr = start.toLocaleDateString('de-DE', dateOptions)
                const startTime = start.toLocaleTimeString('de-DE', timeOptions)
                const endTime = end.toLocaleTimeString('de-DE', timeOptions)

                return `${dateStr}, ${startTime} - ${endTime}`
            },

            getRegisterEventLabel() {
                if (!this.event || !this.event.start_at || !this.event.end_at) {
                    return 'Ich möchte mich zur nächsten Veranstaltung anmelden'
                }

                const start = new Date(this.event.start_at)
                const end = new Date(this.event.end_at)

                // Day of week (e.g., "Mittwoch")
                const weekdayOptions = { weekday: 'long' }
                const weekday = start.toLocaleDateString('de-DE', weekdayOptions)

                // Date format: "am 11. Februar 2026"
                const dateOptions = { day: 'numeric', month: 'long', year: 'numeric' }
                const dateStr = start.toLocaleDateString('de-DE', dateOptions)

                // Time format: "18:00 – 19:30 Uhr"
                const timeOptions = { hour: '2-digit', minute: '2-digit' }
                const startTime = start.toLocaleTimeString('de-DE', timeOptions)
                const endTime = end.toLocaleTimeString('de-DE', timeOptions)

                return `${weekday}, am ${dateStr} um ${startTime} – ${endTime} Uhr`
            },

            submit() {
                let formData = {}
                let that = this

                // Serialize form data
                $(this.$el).find('form')
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData[name] = value
                    })

                // Convert checkbox values to booleans
                formData.register_event = formData.register_event === 'on'
                formData.cme_info = formData.cme_info === 'on'
                formData.form_started_at = this.formStartedAt

                // Validate: at least one toggle must be true
                if (!formData.register_event && !formData.cme_info) {
                    this.toggleValidationError = 'Sie müssen mindestens eine Option auswählen.'
                    Vuemit.fire('Button--sending-failed', true)
                    this.scrollToError()
                    return
                }

                // Clear toggle validation error if validation passes
                this.toggleValidationError = null

                // Add event_id if registering for event
                if (this.event && formData.register_event) {
                    formData.event_id = this.event.id
                }

                this.errors = {}
                this.showSuccessAlert = false

                axios
                    .post('/api/cme/register', formData, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((response) => {
                        that.showSuccessAlert = true

                        // Reset form inputs and trigger blur to fix float labels
                        $(that.$el).find('input[type="email"], input[type="text"]').val('').trigger('blur')

                        // Reset toggles back to default (true)
                        $(that.$el).find('input[type="checkbox"]').prop('checked', true)

                        window.dataLayer = window.dataLayer || []
                        window.dataLayer.push({
                            'event': 'form_cme',
                            'conversion': 'CME registration'
                        })

                        that.honeypotField = ''
                        that.formStartedAt = Math.floor(Date.now() / 1000)

                        Vuemit.fire('Button--sending-failed', true)
                    })
                    .catch((e) => {
                        console.log(e.response)
                        that.errors = e?.response?.data?.errors || {}

                        // Handle toggle validation error from backend
                        if (that.errors.toggles) {
                            that.toggleValidationError = that.errors.toggles[0]
                            delete that.errors.toggles
                        }

                        Vuemit.fire('Button--sending-failed', true)
                        that.scrollToError()
                    })
            },

            async scrollToError() {
                await this.$nextTick()

                var firstError = document.querySelector('.input-error')
                if (firstError) {
                    $('html, body').animate(
                        {
                            scrollTop: $(firstError).offset().top - 180
                        },
                        800
                    )
                }
            },

            closeAlert() {
                this.showSuccessAlert = false
            }
        }
    }
</script>
